import { IBaseServicesArray, ITitleDescription } from "../Interfaces/base";
import { IVideoBanner, IWhiteBoxesWrapper } from "../Interfaces/shared";

const riskFreeIcon: string = require("../assets/images/company/risk-free-icon.svg").default; 
const fraudIcon: string = require("../assets/images/company/fraud-icon.svg").default;
const realTimeIcon: string = require("../assets/images/company/real-time-icon.svg").default;
const streamlineIcon: string = require("../assets/images/company/streamline-icon.svg").default; 
const timeSavingIcon: string = require("../assets/images/company/time-saving-icon.svg").default;
const checklistIcon: string = require("../assets/images/company/checklist-icon.svg").default;
const verifyIdIcon: string = require("../assets/images/services/verify-id-icon.svg").default;
const eSignIcon: string = require("../assets/images/services/eSign-icon.svg").default;
const wetSignIcon: string = require("../assets/images/services/wet-sign-icon.svg").default;
const notaryServiceIcon: string = require("../assets/images/services/notary-icon.svg").default;
const rushIcon: string = require("../assets/images/services/rush-icon.svg").default; 
const coSignerIcon: string = require("../assets/images/services/co-signers-icon.svg").default;
const sealedIcon: string = require("../assets/images/services/seald-icon.svg").default;
const agentReviewIcon: string = require("../assets/images/services/agent-review-icon.svg").default; 
const companyVideo: string = require("../assets/video/company.mp4").default;
const companyVideoMobile: string = require("../assets/video/mobile/company.mp4").default;

const TAB_GENERAL = 'general';
const TAB_DEALER = 'dealer';
const TAB_NOTARY = 'notary';

const TAB_PRICING = 'pricing';
const TAB_SERVICES = 'services';
const TAB_DEALERSHIP = 'dealership';
const TAB_NOTARIES = 'notaries';
const TAB_STATES = 'states';

const COLUMN_LAYOUT = 'column-displayed';
const ROW_LAYOUT = 'row-displayed';

export {
  TAB_DEALER,
  TAB_GENERAL,
  TAB_NOTARY,

  TAB_PRICING,
  TAB_SERVICES,
  TAB_DEALERSHIP,
  TAB_NOTARIES,
  TAB_STATES,

  COLUMN_LAYOUT,
  ROW_LAYOUT
}

export const seo: ITitleDescription = {
  title: 'Seamless eClosings and Remote Signing services | Mavsign',
  description: 'Get on the fast, secure and accurate lane of eClosing. Protect your dealership against Fraud & Identity theft. Reach the growing digital market. Mav that deal!',
}

export const videoBanner: IVideoBanner = {
  title: `<div>Mav<br/> That Deal</div>`,
  description: 'MavSign secures financial contracts that go outside your dealership with digital contracting tools, personalized solutions, and innovative remote signing services for fast, secure, and accurate transactions.',
  video: {
    desktop: companyVideo,
    mobile: companyVideoMobile,
  },
  eventAction: 'request_demo_event_company',
  eventLabel: 'Request Demo Button - Company',
  altText: 'E closing signing service flow between car dealership and remote customer',
  experience: '17+ years of experience',
}

export const benefitsSection: IWhiteBoxesWrapper = {
  subtitle: 'What we do for you',
  title: 'The benefits of registering with Mavsign',
  boxes: [
    {
      icon: {
        src: riskFreeIcon
      },
      title: 'Risk-free Signings',
      description: "Dealership Red Flag compliance, Notary expertise and escalation to our forensic team"
    },
    {
      icon: {
        src: fraudIcon
      },
      title: "Expert Fraud Team",
      description: 'Mavsign due diligence on all Offsite Signings for Fraud attempts and inconsistencies'
    },
    {
      icon: {
        src: realTimeIcon
      },
      title: "Real-time Responses",
      description: 'Client validation Pass or Fail responses received immediately after submission'
    },
    {
      icon: {
        src: streamlineIcon
      },
      title: 'Streamline Operations',
      description: 'Dealership processes easier to manage with the Mavsign platform'
    },
    {
      icon: {
        src: timeSavingIcon
      },
      title: 'Time-saving Processes',
      description: 'Dealership workflow expedited by reliable modern tech infrastructure'
    },
    {
      icon: {
        src: checklistIcon
      },
      title: 'Dealership Checklist',
      description: 'Avoid missing signatures on your complete set of documents'
    }
  ],
}

export const services: IBaseServicesArray[] = [
  {
    icon: {
      src: verifyIdIcon
    },
    readMore:'verify-id',
    title: 'Verify ID',
    description: [`<ul class="ps-3 mb-0">
      <li>Streamlined Identity Verification</li>
      <li>Biometric and ID cross-check</li>
      <li>Instant Pass or Fail results</li>
      <li>Fast decision making</li>
      <li>Safe car transactions</li>
    </ul>`]
  },
  {
    icon: {
      src: eSignIcon
    },
    readMore: 'e-sign',
    title: 'eSign',
    description: [`<ul class="ps-3 mb-0">
      <li>Digital car contracts signing</li>
      <li>Available on all devices</li>
      <li>Share secure document links</li>
      <li>Eliminate physical limitations</li>
      <li>Avoid errors & missing signatures</li>
    </ul>`]
  },
  {
    icon: {
      src: wetSignIcon
    },
    readMore: 'wet-sign',
    title: 'Wet sign',
    description: [`<ul class="ps-3 mb-0">
      <li>Traditional paper docs signing</li>
      <li>Upload paperwork on our platform</li>
      <li>Or deliver contracts to notary</li>
      <li>Signed papers return to dealer</li>
      <li>Tangible record of the transaction</li>
    </ul>`]
  },
  {
    icon: {
      src: notaryServiceIcon
    },
    readMore: 'notary-and-rush',
    title: 'Notary services',
    description: [`<ul class="ps-3 mb-0">
      <li>Over 10,000 US certified notaries</li>
      <li>Deliver docs and witness signings</li>
      <li>Check dealer Red Flag compliance</li>
      <li>Confirm complete contract signing</li>
      <li>Dealer's liaison during process</li>
    </ul>`]
  },
  {
    icon: {
      src: rushIcon
    },
    readMore: 'notary-and-rush',
    title: 'Rush orders',
    description: [`<ul class="ps-3 mb-0">
      <li>Expedite orders for 24 - 48 hours</li>
      <li>Rapid turnaround priority request</li>
      <li>Satisfy urgent customer demands</li>
      <li>Potential for increased revenue</li>
      <li>Competitive edge & risk mitigation</li>
    </ul>`]
  },
  {
    icon: {
      src: coSignerIcon
    },
    readMore: 'co-signer',
    title: 'Co-signer',
    description: [`<ul class="ps-3 mb-0">
      <li>Dual signature contract signings</li>
      <li>Secure deals with a larger market</li>
      <li>Reduce dealership risks</li>
      <li>Speed up the sales process</li>
      <li>Available for all orders</li>
    </ul>`]
  },
  {
    icon: {
      src: sealedIcon
    },
    readMore: 'sealed',
    title: 'Sealed',
    description: [`<ul class="ps-3 mb-0">
      <li>E-seal on completed contracts</li>
      <li>Certifies contracts authenticity</li>
      <li>Disables future edits</li>
      <li>Document integrity</li>
      <li>Legal admissibility</li>
    </ul>`]
  },
  {
    icon: {
      src: agentReviewIcon
    },
    readMore: 'agent-review',
    title: 'Agent Review',
    description: [`<ul class="ps-3 mb-0">
      <li>Manual Red Flag analysis review</li>
      <li>Authenticity, Originality and Validity</li>
      <li>Enforced by our expert Fraud team</li>
      <li>Augmented VerifyID orders</li>
      <li>Extra safety layer against risks</li>
    </ul>`]
  }
]
